import nadiaAvatar from "@/assets/nadia-avatar.webp";

export const NADIA_AVATAR_URL = nadiaAvatar;
